import { render, staticRenderFns } from "./DnDisciplineManagers.vue?vue&type=template&id=601a12b8&scoped=true&"
import script from "./DnDisciplineManagers.vue?vue&type=script&lang=js&"
export * from "./DnDisciplineManagers.vue?vue&type=script&lang=js&"
import style0 from "./DnDisciplineManagers.vue?vue&type=style&index=0&id=601a12b8&lang=scss&scoped=true&"
import style1 from "./DnDisciplineManagers.vue?vue&type=style&index=1&id=601a12b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a12b8",
  null
  
)

export default component.exports